import { OnboardingInviteContainer, InviteContextProvider } from 'src/containers/Onboarding/Invite';
import { usePageMeta } from 'src/hooks';
import { AuthShell } from 'src/components/Layout';

const OnboardingInvitePage = () => {
  usePageMeta('Invite your team members');

  return (
    <AuthShell>
      <InviteContextProvider>
        <OnboardingInviteContainer />
      </InviteContextProvider>
    </AuthShell>
  );
};

export default OnboardingInvitePage;
